var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPvclassImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_online_class_3652282",
    "data-name": "noun_online class_3652282",
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.076,
    height: 71.118,
    viewBox: "0 0 62.076 71.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41911",
    "data-name": "Path 41911",
    d: "M58.281,75.42a1.2,1.2,0,0,1-1.2,1.2H27.321a1.2,1.2,0,1,1,0-2.4h6.52V71a5.118,5.118,0,0,1,5.114-5.114h6.487A5.118,5.118,0,0,1,50.555,71v3.222h6.527A1.2,1.2,0,0,1,58.281,75.42ZM47.916,58.7A5.718,5.718,0,1,0,42.2,64.417,5.718,5.718,0,0,0,47.916,58.7Zm23.276-47.04V38.6h.052a2,2,0,0,1,2,2v2.17a2,2,0,0,1-2,2H13.161a2,2,0,0,1-2-2V40.6a2,2,0,0,1,2-2h.04V11.659h-.04a2,2,0,0,1-2-2V7.5a2,2,0,0,1,2-2H71.244a2,2,0,0,1,2,2V9.66a2,2,0,0,1-2,2H71.2Zm-2.4-1.875H15.6v30.7h53.2ZM36.167,32.437a1.2,1.2,0,0,0,1.2,0l10.862-6.271a1.2,1.2,0,0,0,0-2.076L37.365,17.818a1.2,1.2,0,0,0-1.8,1.038V31.4a1.2,1.2,0,0,0,.6,1.038Z",
    transform: "translate(-11.164 -5.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvclassImg);
export default __webpack_public_path__ + "static/media/pvclass-img.e0a1499f2ebdd7281bf06e7abcf4ceb6.svg";
export { ForwardRef as ReactComponent };